import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { auth } from '../../firebase'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column'
  },
  formControl: {
    margin: theme.spacing.unit,
  },
});

class LoginForm extends Component {

  constructor(props) {
    super(props);
    this.state = { value: '', error: null };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // handleChange(event) {
  //   alert(event.target)
  //   this.setState({ value: event.target.value });
  // }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);
    event.preventDefault();
    // this.state.error = 'test';
    auth.doSignInWithEmailAndPassword(this.state.email, this.state.password)
      .catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // [START_EXCLUDE]
        if (errorCode === 'auth/wrong-password') {
          alert('Wrong password.');
        } else {
          alert(errorMessage);
        }
      })
      .then(() => {
        return <Redirect to='/' />;
      });
    
    // this.setState({ error: 'test' })
  }

  render() {
    const { classes } = this.props;
    return (
      <form className={classes.container} onSubmit={this.handleSubmit} autoComplete="off">
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="name-simple">Email</InputLabel>
          <Input id="name-simple" name="email" type="email" onChange={this.handleInputChange} required />
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="name-helper">Password</InputLabel>
          <Input id="name-helper" name="password" type="password" onChange={this.handleInputChange} required />
        </FormControl>
        <Typography color="error">{this.state.error}</Typography>
        <FormControl className={classes.formControl}>
          <Button variant="raised" color="primary" type="submit" className={classes.button}>Login</Button>
        </FormControl>
      </form>
      // <form onSubmit={this.handleSubmit}>
      //   <label>
      //     Name:
      //     <input type="text" value={this.state.value} onChange={this.handleChange} />
      //   </label>
      //   <input type="submit" value="Submit" />
      // </form>
    );
  }
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginForm);


// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.jsx